import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

export const FooterNav = forwardRef((props, ref) => {
  const { as = 'ul', title, children, flexDir, className, ...rest } = props

  const Comp = as

  const footerNavClasses = [
    `dev_dash__footer-nav ${flexDir ? `dev_dash__footer-nav__${flexDir}` : ''}`,
    className,
  ]
    .join(' ')
    .trim()

  return (
    <>
      {title && <h3 className="dev_dash__footer-nav--title">{title}</h3>}
      <Comp className={footerNavClasses} ref={ref} {...rest}>
        {children}
      </Comp>
    </>
  )
})

FooterNav.displayName = 'FooterNav'

FooterNav.propTypes = {
  as: PropTypes.any,
  title: PropTypes.string,
  children: PropTypes.any.isRequired,
  flexDir: PropTypes.string,
  className: PropTypes.string,
}
